var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{on:{"click":_vm.revert}},[_c('v-icon',{attrs:{"medium":"","color":"lightGrey"}},[_vm._v(" mdi-flip-to-back ")]),_vm._v(" Revert ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }